import { render, staticRenderFns } from "./RecordChooseItem.vue?vue&type=template&id=7e7281ae&"
import script from "./RecordChooseItem.vue?vue&type=script&lang=js&"
export * from "./RecordChooseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports